export enum BpmnExpressionOperators {
    Changed = "Changed",
    Equals = "Equals",
    NotEquals = "NotEquals",
    GreaterThan = "GreaterThan",
    GreaterThanOrEqual = "GreaterThanOrEqual",
    LessThan = "LessThan",
    LessThanOrEqual = "LessThanOrEqual",
    Contains = "Contains",
    NotContains = "NotContains",
    IsEmpty = "IsEmpty",
    IsNotEmpty = "IsNotEmpty",
    InList = "InList",
    NotInList = "NotInList"
}